import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const officetypeAdapter = createEntityAdapter({})

const initialState = officetypeAdapter.getInitialState()

export const officetypeApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getofficetype: builder.query({
            query: () => ({
                url: '/officetype',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedofficetype = responseData.map(officetype => {
                    officetype.id = officetype._id
                    return officetype
                });
                return officetypeAdapter.setAll(initialState, loadedofficetype)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'OFFICETYPE', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'OFFICETYPE', id }))
                    ]
                } else return [{ type: 'OFFICETYPE', id: 'LIST' }]
            }
        }),
        addNewofficetype: builder.mutation({
            query: initialUserData => ({
                url: '/officetype',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'OFFICETYPE', id: "LIST" }
            ]
        }),
        addBulkofficetype: builder.mutation({
            query: initialUserData => ({
                url: '/officetype/addbulk',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'OFFICETYPE', id: "LIST" }
            ]
        }),
        updateofficetype: builder.mutation({
            query: initialUserData => ({
                url: '/officetype',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'OFFICETYPE', id: arg.id },
                { type: 'OFFICETYPE', id: 'LIST' }
            ]
        }),        
        deleteofficetype: builder.mutation({
            query: ({ id }) => ({
                url: `/officetype`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'OFFICETYPE', id: arg.id },
                { type: 'OFFICETYPE', id: 'LIST' }
            ]
        }),
    }),
})

export const {
    useGetofficetypeQuery,
    useAddBulkofficetypeMutation,
    useAddNewofficetypeMutation,
    useUpdateofficetypeMutation,
    useDeleteofficetypeMutation, 
} = officetypeApiSlice
// returns the query result object
export const selectofficetypeResult = officetypeApiSlice.endpoints.getofficetype.select()

// creates memoized selector
const selectofficetypeData = createSelector(
    selectofficetypeResult,
    officetypeResult => officetypeResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllofficetype,
    selectById: selectofficetypeById,
    selectIds: selectofficetypeIds
    // Pass in a selector that returns the users slice of state
} = officetypeAdapter.getSelectors(state => selectofficetypeData(state) ?? initialState)